import * as actionTypes from "../actions/IncidentActions";

const initialState = {
  Loading: false,
  incidentList: [],
  scopeUserIncidentList: [],
  incidentRecord: [],
  incidentCategoriesList: [],
  incidentInstructionsList: [],
  incidentDropdownList: [],
  departmentsDropdownList: [],
  validation_error: "",
  attachment_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal: false,
  session: null, // Add session state
};
const IncidentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INCIDENT_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };

    case actionTypes.DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departmentsDropdownList: action.departmentsDropdownList,
      };

    case actionTypes.INCIDENT_CATEGORIES_SUCCESS:
      return {
        ...state,
        incidentCategoriesList: action.incidentCategoriesList,
      };

    case actionTypes.INCIDENT_INSTRUCTIONS_SUCCESS:
      return {
        ...state,

        incidentInstructionsList: action.incidentInstructionsList,
      };

    case actionTypes.INCIDENT_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        incidentList: action.incidentList,
        showUpdateForm: false,
        showViewPage: false,
        incidentRecord: [],
      };
    case actionTypes.SCOPE_USER_INCIDENT_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        scopeUserIncidentList: action.scopeUserIncidentList,
        showUpdateForm: false,
        showViewPage: false,
        incidentRecord: [],
      };

    case actionTypes.INCIDENT_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        incidentRecord: [],
      };
    case actionTypes.INCIDENT_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        incidentRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.INCIDENT_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        incidentDropdownList: action.incidentDropdownList,
      };

    case actionTypes.REDIRECT_TO_INCIDENT_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        incidentRecord: [],
      };

    case actionTypes.INCIDENT_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_INCIDENT_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };

    default:
      return state;
  }
};

export default IncidentReducer;
